import { render, staticRenderFns } from "./GlobalBackgroundWrapper.vue?vue&type=template&id=a4f8c636&scoped=true"
import script from "./GlobalBackgroundWrapper.vue?vue&type=script&lang=js"
export * from "./GlobalBackgroundWrapper.vue?vue&type=script&lang=js"
import style0 from "./GlobalBackgroundWrapper.vue?vue&type=style&index=0&id=a4f8c636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8c636",
  null
  
)

export default component.exports